import { STATIC_URL } from 'constants/data'

const imageData = {
  split: {
    src: `${STATIC_URL}/program-trial/split_logo.png`,
    alt: 'split',
    width: 208,
    height: 30,
    unoptimized: true,
  },
}

export { imageData }
